import React from 'react';
import { useLocation } from 'react-router-dom';
import AppSidebar from './AppSidebarEnhanced';
import AppTopbar from './AppTopbar';

const authRoutes = ['/login', '/register'];
const independentLayoutRoutes = ['/settings']; // Settings manages its own layout

const LayoutWrapper: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const { pathname } = useLocation();
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [settingsSidebarOpen, setSettingsSidebarOpen] = React.useState(false);

  // Auth routes: no layout at all
  if (authRoutes.includes(pathname)) {
    return <>{children}</>;
  }

  // Settings routes: independent layout with topbar only (no main sidebar)
  if (independentLayoutRoutes.some(route => pathname.startsWith(route))) {
    return (
      <div className="flex flex-col bg-background dark:bg-dark-bg text-text dark:text-dark-text min-h-screen">
        <AppTopbar onMenuClick={() => setSettingsSidebarOpen(v => !v)} />
        <main className="flex-1 overflow-y-auto bg-background dark:bg-dark-bg">
          {React.isValidElement(children)
            ? React.cloneElement(children, {
                settingsSidebarOpen,
                onSettingsSidebarChange: setSettingsSidebarOpen
              } as any)
            : children
          }
        </main>
      </div>
    );
  }

  // Standard layout: main sidebar + topbar + content
  return (
    <div className="flex bg-background dark:bg-dark-bg text-text dark:text-dark-text min-h-screen">
      <AppSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      <div className="flex-1 flex flex-col lg:ml-64 transition-all duration-300">
        <AppTopbar onMenuClick={() => setSidebarOpen(v => !v)} />
        <main className="flex-1 overflow-y-auto p-6 bg-background dark:bg-dark-bg">
          {children}
        </main>
      </div>
    </div>
  );
};

export default LayoutWrapper;
